import {
  GENERAL_CONCEPTUAL_UNDERSTANDING,
  SIGNIFICANT_ERRORS_IN_WORK,
  WORK_IS_COMPLETE_AND_CORRECT
} from 'pages/Teachers/Insights/constants';

export const MASTERY_LEVEL_GRAPH_MAPPER = {
  [WORK_IS_COMPLETE_AND_CORRECT]: {
    graphicYValue: 83.3,
    strokeColor: '#4A8640',
    dotStyle: 'dotGreen',
    color: 'green',
    statusLabel: 'Celebrate'
  },
  [GENERAL_CONCEPTUAL_UNDERSTANDING]: {
    graphicYValue: 50,
    strokeColor: '#C0871E',
    dotStyle: 'dotOrange',
    color: 'yellow',
    statusLabel: 'Support'
  },
  [SIGNIFICANT_ERRORS_IN_WORK]: {
    graphicYValue: 16.6,
    strokeColor: '#CC2762',
    dotStyle: 'dotPink',
    color: 'pink',
    statusLabel: 'Intervene'
  }
};

export const Y_AXIS_TICKS = ['CELEBRATE', 'SUPPORT', 'INTERVENE'];

export const FILTER_OPTIONS_MAP = {
  'Last Month': 'last_month',
  'Last 3 Months': '3_months',
  'Last 6 Months': '6_months'
};

export const GRAPH_RESPONSIVE_CONFIG = {
  [FILTER_OPTIONS_MAP['Last 6 Months']]: {
    pointThreshold: 40,
    multiplierPx: 22
  },
  [FILTER_OPTIONS_MAP['Last 3 Months']]: {
    pointThreshold: 55,
    multiplierPx: 18
  }
};

export const FILTER_DAYS_MAP = {
  'Last Month': 30,
  'Last 3 Months': 90,
  'Last 6 Months': 180
};

export const FILTER_OPTIONS = Object.keys(FILTER_OPTIONS_MAP);
export const DEFAULT_FILTER_VALUE = 'Last 3 Months';

export const GRAPH_LAYOUT = {
  PADDING_LEFT: 6,
  AVAILABLE_WIDTH: 88,
  MAX_X: 94,
  SVG_HEIGHT: 100,
  FALLBACK_GAP: 1.8
};

export const GRID_TIME_CONFIG = {
  MS_PER_DAY: 24 * 60 * 60 * 1000,
  LONG_TERM_THRESHOLD_DAYS: 100,
  MID_TERM_THRESHOLD_DAYS: 35,
  INTERVAL_LONG_DAYS: 30,
  INTERVAL_MID_DAYS: 14,
  INTERVAL_SHORT_DAYS: 7
};
